import { Direction } from "@/generated/TradingGateway"

export const RootPath = {
  index: "/equities/mobile",
  trade: "/equities/mobile/trade",
  tradeInstrument,
  tradeInstrumentTrade,
  tradeInstrumentTradeReceipt,
  orderHistory: "/equities/mobile/orderhistory",
  positions: "/equities/mobile/positions",
}

function tradeInstrument(symbol: string) {
  return `${RootPath.trade}/instrument/${symbol}`
}
tradeInstrument.routePattern = `${RootPath.trade}/instrument/:symbol`

function tradeInstrumentTrade(symbol: string, direction: Direction) {
  return `${RootPath.trade}/instrument/${symbol}/${direction}`
}
tradeInstrumentTrade.routePattern = `${RootPath.trade}/instrument/:symbol/:direction`

function tradeInstrumentTradeReceipt(symbol: string, direction: Direction) {
  return `${RootPath.trade}/instrument/${symbol}/${direction}/receipt`
}
tradeInstrumentTradeReceipt.routePattern = `${RootPath.trade}/instrument/:symbol/:direction/receipt`
